import ReactDOM from 'react-dom';
import React from 'react';

import { getContentExchangePages } from './data-service';
import { CHANGED_FILTER, getFilterState, setFilterState } from './filter';
import {
	CHANGED_TOOLBAR,
	SEARCH,
	getToolbarState,
	setToolbarState
} from './toolbar';
import {
	CHANGED_PAGE,
	goToPage,
	setPageTotal,
	getPageState
} from './pagination';

import { ContentExchangeCard } from './card';
import { ContentExchangeCardUniversity } from './card-university';
import { NoResults } from './no-results';

const $ = jQuery;
let grid = null;
let cardContainer = null;

function onDocumentReady() {
	grid = $('#university-grid').length > 0 ? $('#university-grid') : $('#content-exchange-sidebar');

	if (grid.length > 0) {
		initialize();
	}
}

function initialize() {
	cardContainer = $('.content-exchange-grid-items');

	if (window.history.state) {
		setGridState(window.history.state);
	}

	grid.on(CHANGED_FILTER, onFilterChange);
	grid.on(CHANGED_TOOLBAR, onToolbarChange);
	grid.on(CHANGED_PAGE, onPageChange);
	grid.on(SEARCH, onSearch);

	window.history.replaceState(getGridState(), 'Content Exchange');
	window.addEventListener('popstate', onPopState);

	handleStateChange();
}

function onPopState(e) {
	grid.off(CHANGED_FILTER, onFilterChange);
	grid.off(CHANGED_TOOLBAR, onToolbarChange);
	grid.off(CHANGED_PAGE, onPageChange);
	grid.off(SEARCH, onSearch);

	setGridState(e.state);
	handleStateChange();

	grid.on(CHANGED_FILTER, onFilterChange);
	grid.on(CHANGED_TOOLBAR, onToolbarChange);
	grid.on(CHANGED_PAGE, onPageChange);
	grid.on(SEARCH, onSearch);
}

function onFilterChange() {
	goToPage(1);
}

function onToolbarChange() {
	goToPage(1);
}

function onSearch(e) {
	goToPage(1);
}

function onPageChange() {
	if ('pushState' in window.history) {
		window.history.pushState(getGridState(), 'Content Exchange');
	}

	handleStateChange();
}

function handleStateChange() {
	let containerEl = cardContainer.get(0);
	let gridState = getGridState();

	cardContainer.fadeOut(() => {
		grid.addClass('loading');

		fetchGrid(gridState).then(results => {
			let content = null;
			grid.toggleClass('no-results', results.length === 0);
			if($('#university-grid').length > 0 && results.length > 0){
				content = results.map(ContentExchangeCardUniversity);
			}
			else if ($('#university-grid').length == 0 && results.length > 0) {
				content = results.map(ContentExchangeCard);
			} else {
				content = <NoResults />;
			}
			ReactDOM.render(content, containerEl);
			grid.removeClass('loading');
			cardContainer.fadeIn();
		});
	});
}

function getGridState() {
	let p = getPageState();

	return Object.assign(
		getToolbarState(),
		{ page: p.currentPage },
		{ filter: getFilterState() }
	);
}

function setGridState(state) {
	setFilterState(state.filter);
	setToolbarState(state);
	goToPage(state.page);
}

function fetchGrid(gridState) {
	return getContentExchangePages(gridState).then(r => {
		setPageTotal(Math.ceil(parseInt(r.total, 10) / gridState.postsPerPage));
		return r.results;
	});
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
